export default "__VITE_ASSET__Czir4aUn__"